module.exports = {
  red: 'rgba(204, 0, 0, 1)',
  redLight: 'rgba(242, 149, 148, 1)',
  black: 'rgba(46, 47, 51)',
  blue: 'rgba(3, 92, 171)',
  greyLighter: 'rgba(219, 220, 227)',
  greyLight: 'rgba(190, 192, 205, 1)',
  grey: 'rgba(129, 132, 145, 1)',
  greyDarker: 'rgba(72, 74, 81, 1)',
  green: 'rgba(42, 133, 78)',
  yellowDark: 'rgba(242, 208, 36, 1)',
};



// WEBPACK FOOTER //
// ../shared/optilit-themes/src/low-theme.js